import React from "react";
import heroImage from "../img/hero_banner.png";
import { useNavigate } from "react-router-dom"; // ✅ import useNavigate
import "../css/home.css";
import "../css/responsive.css";
import { FaPhoneAlt, FaArrowRight } from "react-icons/fa";


function Hero() {
  const navigate = useNavigate(); // ✅ initialize navigate
  return (
    <section
      className="hero-section d-flex align-items-center text-white"
      style={{
        backgroundImage: `linear-gradient(
          rgba(0,0,0,0.6),
          rgba(0,0,0,0.6)
        ), url(${heroImage})`,
      }}
    >
      <div className="container text-center">
        <h1 className="hero-title">
          Professional <span>Home Cleaning</span>
        </h1>

        <p className="hero-subtitle">
          Reliable & affordable cleaning services at your doorstep
        </p>

        <div className="hero-buttons text-center">
          <button className="btn btn-primary btn-lg me-3 d-inline-flex align-items-center text-center gap-2" onClick={() => navigate("/contact")}>
             <FaPhoneAlt />
            Book Now
          </button>
          <button className="btn btn-outline-light btn-lg d-inline-flex align-items-center gap-2" onClick={() => navigate("/services")}>
            <FaArrowRight />
            View Services
          </button>
        </div>
      </div>
    </section>
  );
}

export default Hero;
